var _rect, _rect2, _rect3, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 24,
    rx: 2,
    fill: "#B3B8CC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 4.5,
    width: 35,
    height: 4.5,
    fill: "#191E33"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.91667,
    y: 12,
    width: 29.1667,
    height: 7.5,
    fill: "#F8F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.17 13.458L21.2683 14.304V15.234L22.2367 14.778V18H23.17V13.458Z",
    fill: "#030305"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3175 17.208L25.9884 16.362C26.4084 15.828 26.6825 15.396 26.6825 14.844C26.6825 14.088 26.1284 13.548 25.3059 13.548C24.7692 13.548 24.2792 13.782 23.97 14.058V14.982C24.2384 14.736 24.7225 14.412 25.16 14.412C25.5509 14.412 25.755 14.628 25.755 14.958C25.755 15.348 25.3817 15.84 24.985 16.356L23.7134 18H26.805V17.208H25.3175Z",
    fill: "#030305"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3831 14.412H28.8648L28.0073 15.822C28.684 15.84 29.2323 16.074 29.2323 16.596C29.2323 17.01 28.8648 17.274 28.4273 17.274C28.0248 17.274 27.6165 17.1 27.2898 16.794V17.7C27.5756 17.91 27.9431 18.072 28.5031 18.072C29.3373 18.072 30.1073 17.52 30.1073 16.596C30.1073 16.02 29.7573 15.528 29.1681 15.354L30.189 13.62H27.3831V14.412Z",
    fill: "#030305"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBack);
export default __webpack_public_path__ + "static/media/card-back.4f3e3c327244ea48ee183e7e9ca016a6.svg";
export { ForwardRef as ReactComponent };